var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3999 0.605207C14.3459 0.274433 14.0588 0.0219727 13.7128 0.0219727C13.3283 0.0219727 13.0167 0.333651 13.0167 0.718127V1.87838H6.9833V0.718127L6.97419 0.605207C6.92023 0.274433 6.63317 0.0219727 6.28714 0.0219727C5.90267 0.0219727 5.59099 0.333651 5.59099 0.718127V1.87838H3.96662C2.30056 1.87838 0.949951 3.22899 0.949951 4.89505V8.1438V16.9617C0.949951 18.6278 2.30056 19.9784 3.96662 19.9784H16.0333C17.6993 19.9784 19.0499 18.6278 19.0499 16.9617V8.1438V4.89505C19.0499 3.22899 17.6993 1.87838 16.0333 1.87838H14.409V0.718127L14.3999 0.605207ZM17.6576 7.44764V4.89517C17.6576 3.99806 16.9304 3.27081 16.0333 3.27081H14.409V4.43095C14.409 4.81542 14.0973 5.1271 13.7128 5.1271C13.3668 5.1271 13.0797 4.87464 13.0258 4.54387L13.0167 4.43095V3.27081H6.9833V4.43095C6.9833 4.81542 6.67162 5.1271 6.28714 5.1271C5.94112 5.1271 5.65405 4.87464 5.6001 4.54387L5.59099 4.43095V3.27081H3.96662C3.06951 3.27081 2.34226 3.99806 2.34226 4.89517V7.44764H17.6576ZM2.34226 8.83995H17.6576V16.9618C17.6576 17.8589 16.9304 18.5862 16.0333 18.5862H3.96662C3.06951 18.5862 2.34226 17.8589 2.34226 16.9618V8.83995Z",
    fill: "#EE741F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarOrange);
export default __webpack_public_path__ + "static/media/calendar-orange.5bbbe20f3e53aa5229b56e0bed23434b.svg";
export { ForwardRef as ReactComponent };